define(["require", "exports"], function (require, exports) {
    "use strict";
    var Workspaces = /** @class */ (function () {
        function Workspaces() {
        }
        Workspaces.getProjectOverviewUrl = function (projectId) {
            return "/UserProfile/#/Projects/" + projectId + "/Overview";
        };
        Workspaces.getSpecEditDetailsUrl = function (projectId, decorId) {
            return "/Design/#/Projects/" + projectId + "/Specs/Edit/" + decorId + "/Details";
        };
        Workspaces.getSpecEditRevisionsUrl = function (projectId, decorId) {
            return "/Design/#/Projects/" + projectId + "/Specs/Edit/" + decorId + "/History";
        };
        Workspaces.getAreaEditUrl = function (projectId, areaId) {
            return "/Design/#/Projects/" + projectId + "/Areas/AreaDetails/" + areaId;
        };
        Workspaces.getAreaCreateNewUrl = function (projectId) {
            return "/Design/#/Projects/" + projectId + "/Areas/AreaDetails/";
        };
        Workspaces.getSpecTypeEditDetailsUrl = function (decorTypeId) {
            return "/UserProfile/#/SpecTypes/" + decorTypeId + "/Details";
        };
        Workspaces.getSpecTypeEditRelationshipsUrl = function (decorTypeId) {
            return "/UserProfile/#/SpecTypes/" + decorTypeId + "/Relationships";
        };
        Workspaces.getSpecInstructionsEditUrl = function () {
            return "/UserProfile/#/SpecInstructions";
        };
        Workspaces.getReportSetupUrl = function () {
            return "/#/ReportTemplates";
        };
        Workspaces.getDecorTypesCreateNewUrl = function () {
            return "/#/SpecTypes/NEW/Details";
        };
        Workspaces.getDecorCategoriesSetupUrl = function (decorTypeId) {
            return "/#/SpecTypes/" + decorTypeId + "/Details/SpecCategories";
        };
        Workspaces.getReportDesignerUrl = function (reportTypeKey, reportTemplateId) {
            return "/UserProfile/#/ReportTemplates/ReportDesigner2/" + reportTemplateId + "/" + reportTypeKey;
        };
        Workspaces.getReportUrl = function (projectId, reportTemplateId, reportPresetId) {
            if (reportPresetId === void 0) { reportPresetId = ""; }
            var url = "/Design/#/Projects/" + projectId + "/Reports/" + reportTemplateId;
            if (reportPresetId) {
                url += "/" + reportPresetId;
            }
            return url;
        };
        Workspaces.getDecorStageSetupUrl = function () {
            return "/UserProfile/#/DecorStageSetup";
        };
        Workspaces.getCreateCompanyUrl = function (projectId, includeWorkspace) {
            if (includeWorkspace === void 0) { includeWorkspace = true; }
            var nonWorkspaceUrl = "Projects/" + projectId + "/" + this.companyListPageName + "/New";
            return includeWorkspace ? "" + this.userProfileWorkspace + nonWorkspaceUrl : "/" + nonWorkspaceUrl;
        };
        Workspaces.getProjectItemsUrl = function (projectId, includeWorkspace) {
            if (includeWorkspace === void 0) { includeWorkspace = true; }
            var nonWorkspaceUrl = "Projects/" + projectId + "/" + this.projectItemsPageName;
            return includeWorkspace ? "" + this.userProfileWorkspace + nonWorkspaceUrl : "/" + nonWorkspaceUrl;
        };
        Workspaces.getPurchaseOrderVendorsUrl = function (projectId, includeWorkspace) {
            if (includeWorkspace === void 0) { includeWorkspace = true; }
            var nonWorkspaceUrl = "Projects/" + projectId + "/" + this.purchaseOrderVendorsPageName;
            return includeWorkspace ? "" + this.userProfileWorkspace + nonWorkspaceUrl : "/" + nonWorkspaceUrl;
        };
        Workspaces.getProcurementProjectSettingsUrl = function (projectId, includeWorkspace) {
            if (includeWorkspace === void 0) { includeWorkspace = true; }
            var nonWorkspaceUrl = "Projects/" + projectId + "/" + this.procurementProjectSettingsPageName;
            return includeWorkspace ? "" + this.userProfileWorkspace + nonWorkspaceUrl : "/" + nonWorkspaceUrl;
        };
        Workspaces.productLibrary = "ProductLibrary";
        Workspaces.productLibraryStart = Workspaces.productLibrary + ".Start";
        Workspaces.productLibraryProductList = Workspaces.productLibrary + ".ProductList";
        Workspaces.productLibraryProductDetails = Workspaces.productLibrary + ".ProductDetails";
        Workspaces.admin = "Admin";
        Workspaces.adminBilling = Workspaces.admin + ".Billing";
        Workspaces.adminBillingCancelSubscription = Workspaces.adminBilling + ".CancelSubscription";
        Workspaces.adminCustomerSettings = Workspaces.admin + ".CustomerSettings";
        Workspaces.adminCustomerSettingsOfficeAddressDetails = Workspaces.adminCustomerSettings + ".OfficeAddressDetails";
        Workspaces.adminBillingCancelOrSuspendSubscription = Workspaces.adminBilling + ".CancelOrSuspendSubscription";
        Workspaces.main = "Main";
        Workspaces.mainProjects = Workspaces.main + ".Projects";
        Workspaces.mainProjectDetails = Workspaces.mainProjects + ".Details";
        Workspaces.mainProjectDetailsUrl = "/UserProfile/#/Projects/NEW/Edit";
        Workspaces.mainBillingPlanSetup = "Main.Projects.BillingPlanSetup.Setup";
        Workspaces.mainBillingPlanSetupUrl = "/UserProfile/#/Projects/BillingPlanSetup";
        Workspaces.adminBaseUrl = "/Admin";
        Workspaces.adminBillingUrl = "/UserProfile/#/Billing";
        Workspaces.freeTrialExpiredUrl = "/UserProfile/#/FreeTrialExpired";
        Workspaces.accountCancelledUrl = "/UserProfile/#/AccountCancelled";
        Workspaces.accountOnHoldUrl = "/UserProfile/#/AccountOnHold";
        Workspaces.mainDashboardUrl = "/UserProfile/#/Dashboard";
        Workspaces.mainDashboardWelcome = "Main.Dashboard.Welcome";
        Workspaces.mainReportDesigner = Workspaces.main + ".ReportDesigner";
        Workspaces.mainReportTemplates = Workspaces.main + ".ReportTemplates";
        Workspaces.mainReportSetupUrl = "/UserProfile/#/ReportSetup";
        Workspaces.mainDecorTypes = Workspaces.main + ".DecorTypes";
        Workspaces.mainDecorTypesEdit = Workspaces.mainDecorTypes + ".DecorTypeEdit";
        Workspaces.mainDecorTypesEditDetails = Workspaces.mainDecorTypesEdit + ".Details";
        Workspaces.mainDecorTypesEditDetailsManageDecorCategories = Workspaces.mainDecorTypesEditDetails + ".DecorCategories";
        Workspaces.project = "Design";
        Workspaces.projectOverview = Workspaces.project + ".Overview";
        Workspaces.projectOverviewProjectDetails = Workspaces.projectOverview + ".ProjectDetails";
        Workspaces.projectReports = Workspaces.project + ".Reports";
        Workspaces.projectAreaFloorEdit = Workspaces.project + ".Areas.FloorsEdit";
        Workspaces.projectBudgetEdit = Workspaces.project + ".BudgetEdit";
        Workspaces.projectBudgetEditSpecEditDetails = Workspaces.projectBudgetEdit + ".Edit.Details";
        //public static projectBudgetEdit = Workspaces.project + ".BudgetEdit";
        //public static projectBudgetEditSpecEditRoot = Workspaces.projectBudgetEdit + ".Spec";
        //public static projectBudgetEditSpecEditDetails = Workspaces.projectBudgetEditSpecEditRoot + ".Edit.Details";
        Workspaces.projectSpecs = Workspaces.project + ".Specs";
        Workspaces.projectSpecEdit = Workspaces.projectSpecs + ".Edit";
        Workspaces.projectSpecCodingWizard = Workspaces.projectSpecs + ".SpecCodingWizard";
        Workspaces.projectSpecAreaSelect = Workspaces.projectSpecs + ".SpecAreaSelect";
        Workspaces.projectBatchSpecAreaAssign = Workspaces.projectSpecs + ".BatchSpecAreaAssign";
        Workspaces.projectSpecEditDetails = Workspaces.projectSpecEdit + ".Details";
        Workspaces.projectSpecEditLinkedSpecs = Workspaces.projectSpecEdit + ".Relationships";
        Workspaces.projectSpecsCopy = Workspaces.projectSpecs + ".Copy";
        Workspaces.projectSpecsBatchEdit = Workspaces.projectSpecs + ".BatchEdit";
        Workspaces.projectPurchasing = Workspaces.project + ".Purchasing";
        Workspaces.projectPurchasingVendors = Workspaces.projectPurchasing + ".Vendors";
        Workspaces.projectPurchaseOrderListEdit = Workspaces.projectPurchasing + ".PurchaseOrderListEdit";
        Workspaces.projectTrackingShipmentsListEdit = Workspaces.projectPurchasing + ".TrackingShipmentsListEdit";
        Workspaces.projectPurchaseItems = Workspaces.projectPurchasing + ".ProjectItems";
        Workspaces.projectPurchasingSettings = Workspaces.projectPurchasing + ".ProjectSettings";
        Workspaces.projectPurchaseOrder = Workspaces.project + ".PurchaseOrder";
        Workspaces.projectPurchaseOrderItems = Workspaces.projectPurchaseOrder + ".Items";
        Workspaces.projectPurchaseOrderItemsSelectPO = Workspaces.projectPurchaseItems + ".SelectPurchaseOrder";
        Workspaces.projectPurchaseOrderVendors = Workspaces.projectPurchaseOrderItems + ".Vendors";
        Workspaces.projectPurchaseOrderDetails = Workspaces.projectPurchaseOrder + ".Details";
        Workspaces.projectPurchaseOrderTracking = Workspaces.projectPurchaseOrder + ".Tracking";
        Workspaces.projectPurchaseSpecEditDetails = Workspaces.projectPurchaseItems + ".Edit.Details";
        Workspaces.projectCompaniesAndPeople = Workspaces.project + ".CompaniesAndPeople";
        Workspaces.projectCompanyListEdit = Workspaces.projectCompaniesAndPeople + ".CompanyListEdit";
        Workspaces.projectCompanyRepresentativeListEdit = Workspaces.projectCompaniesAndPeople + ".RepresentativeListEdit";
        Workspaces.projectCompanyEdit = Workspaces.project + ".CompanyEdit";
        Workspaces.projectCompanyEditDetails = Workspaces.projectCompanyEdit + ".Details";
        Workspaces.projectCompanyEditRepresentatives = Workspaces.projectCompanyEdit + ".Representatives";
        Workspaces.projectCompanyManufacturersEdit = Workspaces.projectCompanyEdit + ".Manufacturers";
        Workspaces.projectCompanyVendorsEdit = Workspaces.projectCompanyEdit + ".Vendors";
        Workspaces.projectCompanyRepresentativeEdit = Workspaces.project + ".CompanyRepresentativeEdit";
        Workspaces.userProfile = "UserProfile";
        Workspaces.projectWorkspace = "/Design/#/";
        Workspaces.userProfileWorkspace = "/UserProfile/#/";
        Workspaces.guestPseudoWorkspace = "/Guest/#/";
        Workspaces.guestBillingAreas = ["GuestBilling"];
        // #region New angular links. Check workspaces.ts in new angular if modifying this region
        Workspaces.companyListPageName = "Companies";
        Workspaces.projectItemsPageName = "ProjectItems";
        Workspaces.purchaseOrderVendorsPageName = "PurchaseOrderVendors";
        Workspaces.procurementProjectSettingsPageName = "ProcurementProjectSettings";
        return Workspaces;
    }());
    return Workspaces;
});
//# sourceMappingURL=Workspaces.js.map